import { request_zzquant } from '@/network/request'

const ANONYMOUS_KEY = 'zz_product_anonymous_id'

function anonymousId() {
  try {
    let value = localStorage.getItem(ANONYMOUS_KEY)
    if (!value) {
      value = 'web-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12)
      localStorage.setItem(ANONYMOUS_KEY, value)
    }
    return value
  } catch (e) {
    return null
  }
}

export function trackProductEvent(eventName, payload = {}) {
  const data = Object.assign({}, payload, { event_name: eventName, anonymous_id: anonymousId() })
  request_zzquant({ url: '/v3/topic/events', method: 'POST', data, noRedirect: true, timeout: 5000 }).catch(() => {})
}
